// lib/components/table/standard-table/components/draggable.tsx
import {
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  SortableContext,
  arrayMove,
  verticalListSortingStrategy
} from "@dnd-kit/sortable";
import { jsx } from "@emotion/react/jsx-runtime";
var handleDragEnd = (items, onDragged) => {
  return (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      const oldIndex = items.findIndex((item) => item.id === active.id);
      const newIndex = items.findIndex((item) => item.id === over.id);
      onDragged(arrayMove(items, oldIndex, newIndex));
    }
  };
};
var Draggable = ({
  items,
  children,
  onDragged
}) => {
  const pointerSensor = useSensor(PointerSensor, {});
  const keyboardSensor = useSensor(KeyboardSensor, {});
  const sensors = useSensors(pointerSensor, keyboardSensor);
  return /* @__PURE__ */ jsx(
    DndContext,
    {
      onDragEnd: handleDragEnd(items, onDragged),
      modifiers: [restrictToVerticalAxis],
      accessibility: {
        container: document.getElementById("__next") ?? void 0
      },
      sensors,
      autoScroll: { canScroll: (e) => e.tagName !== "HTML" },
      children: /* @__PURE__ */ jsx(SortableContext, { items, strategy: verticalListSortingStrategy, children })
    }
  );
};

export {
  Draggable
};
